// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1W9QQ","rootSuccess":"CompleteLink_rootSuccess__2NUOc","rootFailure":"CompleteLink_rootFailure__3yIfz","isDisabled":"CompleteLink_isDisabled__3boFi"};